import { ITag } from '@/types/Tag';
import { apolloClient } from '@/apollo';
import { getTagsQuery } from '@/tags/graphql/tag.queries';
import {
  addTagsMutation,
  createTagMutation,
  removeTagsMutation,
} from '@/tags/graphql/tag.mutations';

const getTags = async (): Promise<ITag[]> => {
  const {
    data: { tags },
  } = await apolloClient.query({
    query: getTagsQuery,
  });
  return tags;
};

const addDocumentTags = async (documentIds: string[], tagIds: string[]): Promise<any[]> => {
  const {
    data: { addDocumentTags },
  } = await apolloClient.mutate({
    mutation: addTagsMutation,
    variables: { documentIds, tagIds },
  });
  return addDocumentTags;
};

const createTag = async (tagName: string): Promise<ITag> => {
  const {
    data: { createTag },
  } = await apolloClient.mutate({
    mutation: createTagMutation,
    variables: { title: tagName },
  });
  return createTag;
};

const removeDocumentTags = async (documentIds: string[], tagIds: string[]): Promise<boolean> => {
  const {
    data: { removeDocumentTags },
  } = await apolloClient.mutate({
    mutation: removeTagsMutation,
    variables: { documentIds, tagIds },
  });
  return removeDocumentTags;
};

export default {
  createTag,
  addDocumentTags,
  removeDocumentTags,
  getTags,
};
